import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { BehaviorSubject } from 'rxjs';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { RequestProductDto } from 'projects/cupcake/src/app/xatena-api';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-supplier-contact-cell-renderer',
  templateUrl: './supplier-contact-cell-renderer.component.html',
  styleUrls: ['./supplier-contact-cell-renderer.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
})
export class SupplierContactCellRendererComponent
  implements ICellRendererAngularComp
{
  params!: ICellRendererParams;
  value$ = new BehaviorSubject<RequestProductDto | null>(null);

  constructor() {}

  onClick(): void {
    this.params.eGridCell.click();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.value$.next(this.params.data);
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value$.next(this.params.data);
  }
}
